import HomeAssumptionsAllianzOwnLivePage from './HomeAssumptionsAllianzOwnLivePage';

export default HomeAssumptionsAllianzOwnLivePage;
